module.exports = __webpack_public_path__ + "img/dual-heating.a735e41f.svg";